export class DownloadLinkHelper {
    static getDownloadFileName(fileName, downloadName, extention) {
        if(undefined === downloadName || null === downloadName || "" === downloadName) {
            return fileName;
        }

        let fileExtention = extention.toLowerCase();
        if (!fileExtention.startsWith(".")) {
            fileExtention = `.${fileExtention}`;
        }

        return `${downloadName}${fileExtention}`;
    }
}


// WEBPACK FOOTER //
// ./src/components/helpers/DownloadLinkHelper.js